import { render, staticRenderFns } from "./ModelBuild.vue?vue&type=template&id=17437f5a&scoped=true&"
import script from "./ModelBuild.vue?vue&type=script&lang=ts&"
export * from "./ModelBuild.vue?vue&type=script&lang=ts&"
import style0 from "./ModelBuild.vue?vue&type=style&index=0&id=17437f5a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17437f5a",
  null
  
)

export default component.exports